import { useMutation } from '@tanstack/react-query';

import { submitFunnelEmailCapture } from '@lib/api/funnel-email-capture';

export const useFunnelEmailCapture = () =>
  useMutation({ mutationFn: submitFunnelEmailCapture });
